module.exports = __webpack_public_path__ + "img/banner-challenge.0f0e39c4.png";